// Components
import { FeaturedCardSkeleton } from './FeaturedCardSkeleton';
import { BlogCardSkeleton } from './BlogCardSkeleton';
import { Skeleton } from './Skeleton';

/**
 * Full page skeleton for the Resources page
 * Shows while data is being fetched from Sanity
 */
export const ResourcesPageSkeleton = () => {
  return (
    <div className="flex flex-col items-center w-full bg-white">
      {/* Hero Section */}
      <section className="flex flex-col items-center gap-[var(--spacing-24)] px-[var(--spacing-24)] pt-[var(--spacing-64)] pb-[var(--spacing-32)] w-full max-w-[1016px] max-md:px-[var(--spacing-16)] max-md:pt-[var(--spacing-48)]">
        {/* Title */}
        <div className="flex flex-col items-center gap-[var(--spacing-24)] text-center">
          <Skeleton className="h-[72px] w-[320px] max-md:h-[56px] max-md:w-[240px]" />
          <Skeleton className="h-[40px] w-full max-w-[600px]" />
        </div>

        {/* Resource Type Buttons */}
        <div className="flex items-center gap-[var(--spacing-16)] flex-wrap justify-center">
          <Skeleton className="h-[48px] w-[120px] rounded-8" />
          <Skeleton className="h-[48px] w-[100px] rounded-8" />
          <Skeleton className="h-[48px] w-[110px] rounded-8" />
        </div>

        {/* Filters */}
        <div className="flex items-center gap-[var(--spacing-24)] w-full max-md:flex-col max-md:gap-[var(--spacing-16)]">
          <Skeleton className="h-[56px] flex-1 rounded-8 max-md:w-full" />
          <Skeleton className="h-[56px] flex-1 rounded-8 max-md:w-full" />
          <Skeleton className="h-[56px] flex-1 rounded-8 max-md:w-full" />
        </div>
      </section>

      {/* Featured Post Skeleton */}
      <section className="flex justify-center px-[var(--spacing-24)] py-[var(--spacing-32)] w-full max-md:px-[var(--spacing-16)]">
        <FeaturedCardSkeleton />
      </section>

      {/* Blog Cards Grid Skeleton */}
      <section className="flex justify-center px-[var(--spacing-24)] py-[var(--spacing-32)] w-full max-md:px-[var(--spacing-16)]">
        <div className="grid grid-cols-3 gap-[var(--spacing-24)] w-full max-w-[1016px] max-lg:grid-cols-2 max-md:grid-cols-1">
          {Array.from({ length: 6 }).map((_, index) => (
            <BlogCardSkeleton key={index} className="max-w-none" />
          ))}
        </div>
      </section>
    </div>
  );
};

